import { styled, Box } from "@mui/material";

export const BetweenLine = styled(Box)(() => ({
  height: "0.05rem",
  width: "1rem",
  backgroundColor: "rgba(0, 0, 0, 0.5)",
}));
